<div class="container">
  <div class="know-more">
    <div class="glassdoor">
      <!-- <img data-src="/assets/images/team/glassdoor_pc.svg" class="d-none d-lg-block d-md-block">
      <img data-src="/assets/images/team/glassdoor_mob.svg" class="d-block d-lg-none d-md-none d-sm-block"> -->
      <a href="https://www.glassdoor.co.in/Overview/Working-at-Ketto-EI_IE2034328.11,16.htm"><img alt="Find us on Glassdoor." src="https://www.glassdoor.co.in/api/widget/verticalStarRating.htm?e=2034328"></a>
      <!-- <a href="https://www.glassdoor.co.in/Overview/Working-at-Ketto-EI_IE2034328.11,16.htm" target="_blank" class="view-btn-g a-btn" mat-raised-button>View On Glassdoor</a> -->
    </div>
    <div class="linkedin">
      <img data-src="/assets/images/team/linkedin_pc.svg" class="d-none d-lg-block d-md-block">
      <img data-src="/assets/images/team/linkedin_mob.svg" class="d-block d-lg-none d-md-none d-sm-block">
      <a href="https://www.linkedin.com/company/ketto-online-ventures-private-limited/" target="_blank" class="view-btn-l a-btn" mat-raised-button>View Profile</a>
    </div>
  </div>
</div>